import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';

interface BreadCrumbProps {
    title: string;
    pageTitle: string | string[];
}

const BreadCrumb = ({ title, pageTitle }: BreadCrumbProps) => {
    const pages = Array.isArray(pageTitle) ? pageTitle : [pageTitle];
    return (
        <React.Fragment>
            <Row>
                <Col xs={12}>
                    <div className="page-title d-sm-flex align-items-center justify-content-between border-0  rounded-4 mb-3 ms-1 p-1  ">
                        <h5 className="mb-sm-0">{title}</h5>

                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                {pages.map((page, index) => (
                                    <li
                                        key={index}
                                        className={`breadcrumb-item ${index === pages.length - 1 ? "active" : ""}`}
                                    >
                                        {index === pages.length - 1 ? (
                                            page
                                        ) : (
                                            <Link to="#">{page}</Link>
                                        )}
                                    </li>
                                ))}
                                {/* <li className="breadcrumb-item active">{title}</li> */}
                            </ol>
                        </div>

                    </div>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default BreadCrumb;